export default __webpack_public_path__ + "static/media/white-circle-measure-icon.dbfa553d.svg";